
import { defineComponent, PropType } from "vue";
import ProgressBar from "./ProgressBar.vue";
import { Note } from "@/components/layout";
import { SkillDto } from "@/types";

export default defineComponent({
  name: "Skill",
  components: { ProgressBar, Note },
  props: {
    skill: {
      type: Object as PropType<SkillDto>,
    },
  },
});
